import { SawQualityChecksReportPage } from "../../pages/sawlines/quality-checks-report";

export const routeSawQualityChecksReport = "/saw-quality-checks/report";

export const sawQualityChecksRoutes = [
	{
		path: routeSawQualityChecksReport,
		element: <SawQualityChecksReportPage />,
	},
];
